import { useContext } from 'react';
import { AddNotificationContext } from "./AddNotificationContext.js";
export var useAddNotificationContext = function () {
    return useContext(AddNotificationContext);
};
//# sourceMappingURL=useAddNotificationContext.js.map